import { render } from "./search_and_filters_old.vue?vue&type=template&id=681b5690"
import script from "./search_and_filters_old.vue?vue&type=script&lang=ts"
export * from "./search_and_filters_old.vue?vue&type=script&lang=ts"
script.render = render

export default script